import dagre from "@dagrejs/dagre"
import { Node, NodeCategory } from "@/nodes"

const dagreGraph = new dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}))

const nodeWidth = 200
const nodeHeight = 110

export const getLayoutedElements = (nodes, edges, direction = "TB") => {
  const isHorizontal = direction === "LR"
  dagreGraph.setGraph({ rankdir: direction })

  nodes.forEach((node) => {
    dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight })
  })

  edges.forEach((edge) => {
    dagreGraph.setEdge(edge.source, edge.target)
  })

  dagre.layout(dagreGraph)

  const newNodes = nodes.map((node) => {
    const nodeWithPosition = dagreGraph.node(node.id)
    const newNode = {
      ...node,
      targetPosition: isHorizontal ? "left" : "top",
      sourcePosition: isHorizontal ? "right" : "bottom",
      // We are shifting the dagre node position (anchor=center center) to the top left
      // so it matches the React Flow node anchor point (top left).
      position: {
        x: nodeWithPosition.x - nodeWidth / 2,
        y: nodeWithPosition.y - nodeHeight / 2,
      },
    }

    return newNode
  })

  return { nodes: newNodes, edges }
}

// const extractTriggerFromNode = (node: Node) => {
//   let triggerNodes: Node[] = []
//   const { actions, ...baseNode } = node

//   triggerNodes.push({
//     ...baseNode,
//     type: `trigger:${baseNode.type}`,
//     category: NodeCategory.TRIGGER,

//     actions:
//       [{
//         id: "trigger",
//         label: "Trigger",
//         operations: node.triggers?.forEach((triggerOperation) => {
//           return {
//             ...triggerOperation,
//           }
//         }
//         ) as any,
//       }],
//   })

//   return triggerNodes
// }

// export const mergeTriggerNodes = (nodes: Node[]) => {
//   const triggerNodes: Node[] = []
//   nodes.forEach((node) => {
//     if (node.triggers?.length) {
//       nodes.ac
//     }
//   })

//   console.log("triggerNodes", triggerNodes)

//   return [...nodes.filter(x => x.category !== NodeCategory.TRIGGER), ...triggerNodes]
// }
